import { Navigate, Outlet } from "react-router-dom";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { useIsSuperAdmin } from "@/hooks/useIsSuperAdmin";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export function SuperAdminRoute() {
  const { data: user, isLoading: userLoading } = useCurrentUser();
  const { data: isSuperAdmin, isLoading: roleLoading } = useIsSuperAdmin();

  // Show loading state while checking permissions
  if (userLoading || roleLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  // Redirect to auth if no user
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  // Show access denied if not super admin
  if (!isSuperAdmin) {
    return (
      <div className="container mx-auto px-4 py-16 max-w-2xl">
        <Alert variant="destructive" className="border-destructive/50">
          <ShieldAlert className="h-5 w-5" />
          <AlertDescription className="mt-2">
            <h3 className="font-semibold text-lg mb-2">Access Denied</h3>
            <p className="text-sm mb-4">
              You don't have permission to access the admin panel. This area is restricted to super administrators only.
            </p>
            <Button asChild variant="outline" size="sm">
              <Link to="/dashboard">Return to Dashboard</Link>
            </Button>
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return <Outlet />;
}
